import {configureStore} from '@reduxjs/toolkit';

import TableReducer from './TableRedux/TableRedux';
import SettingReducer from './SettingRedux/SettingRedux';

export const store = configureStore({
    reducer: {

        SettingRedux: SettingReducer,
        TableRedux: TableReducer,

    },
});

export default store;
